'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _NotFound = require('./NotFound.scss');

var _NotFound2 = _interopRequireDefault(_NotFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    location: state.routing.locationBeforeTransitions
  };
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(NotFound, _React$Component);

  function NotFound(props) {
    (0, _classCallCheck3.default)(this, NotFound);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).call(this, props));

    _this.puppyMove = '(function(){\n      function dogLookLeft(){\n            document.querySelector(".doggy-standing").style.display = "none";\n            document.querySelector(".doggy-jumping").style.display = "none";\n            document.querySelector(".doggy-sitting").style.display = "block";\n            document.querySelector(".look-left").style.display = "block";\n            document.querySelector(".look-right").style.display = "none";\n      }\n      function dogLookRight(){\n            document.querySelector(".doggy-jumping").style.display = "none";\n            document.querySelector(".look-left").style.display = "none";\n            document.querySelector(".look-right").style.display = "block";\n            document.querySelector(".doggy-standing").style.display = "none";\n      }\n    \n      function dogStand(){\n            document.querySelector(".look-right").style.display = "none";\n            document.querySelector(".doggy-sitting").style.display = "none";\n            document.querySelector(".doggy-standing").style.display = "block";\n            document.querySelector(".doggy-jumping").style.display = "none";\n      }\n      function dogJump(){\n          document.querySelector(".doggy-sitting").style.display = "none";\n          document.querySelector(".look-left").style.display = "none";\n          document.querySelector(".look-right").style.display = "none";\n          document.querySelector(".doggy-standing").style.display = "none";\n          document.querySelector(".doggy-jumping").style.display = "block";\n      }\n      var pause = function() {\n         var promise = new Promise(function(nextSlide, reject){\n            setTimeout(function() {\n           dogLookLeft();\n               nextSlide();\n            }, 2000);\n         });\n         return promise;\n      };\n      var lookLeft = function() {\n         var promise = new Promise(function(nextSlide, reject){\n            setTimeout(function() {\n           dogLookLeft();\n               nextSlide();\n            }, 300);\n         });\n         return promise;\n      };\n      var lookRight = function() {\n         var promise = new Promise(function(nextSlide, reject){\n            setTimeout(function() {\n           dogLookRight();\n                nextSlide();\n            }, 300);\n         });\n         return promise;\n      };\n      var standingDog = function() {\n         var promise = new Promise(function(nextSlide, reject){\n            setTimeout(function() {\n           dogStand();\n               nextSlide();\n            }, 300);\n         });\n         return promise;\n      };\n      var jumpingDog = function() {\n         var promise = new Promise(function(nextSlide, reject){\n            setTimeout(function() {\n           dogJump();\n               nextSlide();\n            }, 300);\n         });\n         return promise;\n      };\n      function playAnimation() {\n        lookLeft()\n            .then(pause)\n           .then(lookRight)\n           .then(lookLeft)\n              .then(lookRight)\n              .then(lookLeft)\n           .then(standingDog)\n           .then(jumpingDog)\n              .then(standingDog)\n           .then(jumpingDog)\n             .then(standingDog)\n           .then(lookLeft)\n      }\n      playAnimation();\n      setInterval(playAnimation, 3300);\n    })();';
    return _this;
  }

  (0, _createClass3.default)(NotFound, [{
    key: 'render',
    value: function render() {
      // eslint-disable-next-line prefer-destructuring
      var location = this.props.location;
      return _react2.default.createElement(
        'div',
        { className: _NotFound2.default.notfound },
        location.basename && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement('script', { type: 'application/javascript', dangerouslySetInnerHTML: { __html: this.puppyMove } }),
          _react2.default.createElement(
            'div',
            { className: 'doggy-container' },
            _react2.default.createElement(
              'h1',
              null,
              '404'
            ),
            _react2.default.createElement('div', { className: 'bg-colour' }),
            _react2.default.createElement(
              'div',
              { className: 'doggy doggy-sitting' },
              _react2.default.createElement(
                'div',
                { className: 'dog-head-container look-left' },
                _react2.default.createElement('div', { className: 'dog-left-ear' }),
                _react2.default.createElement('div', { className: 'dog-head-2' }),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-head' },
                  _react2.default.createElement('div', { className: 'dog-nose' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-head-spot' },
                  _react2.default.createElement('div', { className: 'dog-eye' })
                ),
                _react2.default.createElement('div', { className: 'dog-right-ear' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'dog-head-container look-right' },
                _react2.default.createElement('div', { className: 'dog-left-ear' }),
                _react2.default.createElement('div', { className: 'dog-head-2' }),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-head' },
                  _react2.default.createElement('div', { className: 'dog-nose' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-head-spot' },
                  _react2.default.createElement('div', { className: 'dog-eye' })
                ),
                _react2.default.createElement('div', { className: 'dog-right-ear' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'collar' },
                _react2.default.createElement('div', { className: 'collar-shade' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'dog-torso' },
                _react2.default.createElement(
                  'div',
                  { className: 'dog-torso-shade' },
                  _react2.default.createElement(
                    'div',
                    { className: 'light-right-dog-foot' },
                    _react2.default.createElement(
                      'div',
                      { className: 'swipes swipe-chest swipe-chest-light-right' },
                      _react2.default.createElement('div', { className: 'swipe-1-light-right grey-swipe' }),
                      _react2.default.createElement('div', { className: 'swipe-2-light-right grey-swipe' })
                    )
                  ),
                  _react2.default.createElement('div', { className: 'light-right-dog-paw' })
                ),
                _react2.default.createElement('div', { className: 'left-dog-foot' }),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-torso-light' },
                  _react2.default.createElement(
                    'div',
                    { className: 'swipes swipe-chest swipe-chest-light' },
                    _react2.default.createElement('div', { className: 'swipe-1-light grey-swipe' }),
                    _react2.default.createElement('div', { className: 'swipe-2-light grey-swipe' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-torso-chest' },
                  _react2.default.createElement(
                    'div',
                    { className: 'swipes swipe-chest' },
                    _react2.default.createElement('div', { className: 'swipe-1 grey-swipe' }),
                    _react2.default.createElement('div', { className: 'swipe-2 grey-swipe' })
                  )
                ),
                _react2.default.createElement('div', { className: 'right-dog-foot' })
              ),
              _react2.default.createElement('div', { className: 'doggy-cushion' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'doggy doggy-standing' },
              _react2.default.createElement(
                'div',
                { className: 'dog-head-container look-left dog-head-standing-up' },
                _react2.default.createElement('div', { className: 'dog-left-ear dog-left-ear-standing' }),
                _react2.default.createElement('div', { className: 'dog-head-2' }),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-head' },
                  _react2.default.createElement('div', { className: 'dog-nose' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-head-spot dog-head-spot-standing' },
                  _react2.default.createElement('div', { className: 'dog-eye' })
                ),
                _react2.default.createElement('div', { className: 'dog-right-ear dog-right-ear-standing' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'collar collar-standing-up' },
                _react2.default.createElement('div', { className: 'collar-shade' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'dog-torso dog-torso-standing-up' },
                _react2.default.createElement('div', { className: 'right-leg-standing' }),
                _react2.default.createElement('div', { className: 'right-hind-standing' }),
                _react2.default.createElement(
                  'div',
                  { className: 'left-leg-standing' },
                  _react2.default.createElement(
                    'div',
                    { className: 'swipes swipe-chest swipe-chest-light-right swipe-chest-standing-2' },
                    _react2.default.createElement('div', { className: 'swipe-1-light-right grey-swipe' }),
                    _react2.default.createElement('div', { className: 'swipe-2-light-right grey-swipe' })
                  )
                ),
                _react2.default.createElement('div', { className: 'left-hind-standing' }),
                _react2.default.createElement('div', { className: 'left-dog-foot left-dog-foot-standing' }),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-torso-chest dog-chesting-standing-up ' },
                  _react2.default.createElement(
                    'div',
                    { className: 'swipes swipe-chest' },
                    _react2.default.createElement('div', { className: 'swipe-1 grey-swipe' }),
                    _react2.default.createElement('div', { className: 'swipe-2 grey-swipe' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-torso-light-standing' },
                  _react2.default.createElement(
                    'div',
                    { className: 'swipes swipe-chest swipe-chest-light-right swipe-chest-standing-1' },
                    _react2.default.createElement('div', { className: 'swipe-1-light-right grey-swipe' }),
                    _react2.default.createElement('div', { className: 'swipe-2-light-right grey-swipe' })
                  )
                ),
                _react2.default.createElement('div', { className: 'right-dog-foot right-dog-foot-standing' })
              ),
              _react2.default.createElement('div', { className: 'doggy-cushion doggy-cushion-standing' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'doggy doggy-jumping' },
              _react2.default.createElement(
                'div',
                { className: 'stars' },
                _react2.default.createElement('div', { className: 'circle-star circle-star-1' }),
                _react2.default.createElement('div', { className: 'circle-star circle-star-2' }),
                _react2.default.createElement('div', { className: 'circle-star circle-star-3' }),
                _react2.default.createElement('div', { className: 'circle-star circle-star-4' }),
                _react2.default.createElement('div', { className: 'diamond-star diamond-star-1' }),
                _react2.default.createElement('div', { className: 'diamond-star diamond-star-2' }),
                _react2.default.createElement('div', { className: 'diamond-star diamond-star-3' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'dog-head-container look-left dog-head-standing-up' },
                _react2.default.createElement('div', { className: 'dog-left-ear dog-left-ear-jumping' }),
                _react2.default.createElement('div', { className: 'dog-head-2' }),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-head' },
                  _react2.default.createElement('div', { className: 'dog-nose' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-head-spot dog-head-spot-standing' },
                  _react2.default.createElement('div', { className: 'dog-eye' })
                ),
                _react2.default.createElement('div', { className: 'dog-right-ear dog-right-ear-jumping' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'collar collar-standing-up' },
                _react2.default.createElement('div', { className: 'collar-shade' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'dog-torso dog-torso-standing-up' },
                _react2.default.createElement(
                  'div',
                  { className: 'right-leg-standing' },
                  _react2.default.createElement(
                    'div',
                    { className: 'swipes swipe-chest swipe-chest-light-right swipe-chest-jumping-1' },
                    _react2.default.createElement('div', { className: 'swipe-1-light-right grey-swipe' }),
                    _react2.default.createElement('div', { className: 'swipe-2-light-right grey-swipe' })
                  )
                ),
                _react2.default.createElement('div', { className: 'right-hind-standing right-hind-jumping' }),
                _react2.default.createElement('div', { className: 'left-leg-standing left-leg-jumping ' }),
                _react2.default.createElement('div', { className: 'left-hind-standing left-hind-jumping' }),
                _react2.default.createElement('div', { className: 'left-dog-foot left-dog-foot-jumping' }),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-torso-chest dog-chesting-standing-up ' },
                  _react2.default.createElement(
                    'div',
                    { className: 'swipes swipe-chest' },
                    _react2.default.createElement('div', { className: 'swipe-1 grey-swipe' }),
                    _react2.default.createElement('div', { className: 'swipe-2 grey-swipe' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'dog-torso-light-standing' },
                  _react2.default.createElement(
                    'div',
                    { className: 'swipes swipe-chest swipe-chest-light-right swipe-chest-jumping-2' },
                    _react2.default.createElement('div', { className: 'swipe-1-light-right grey-swipe' }),
                    _react2.default.createElement('div', { className: 'swipe-2-light-right grey-swipe' })
                  )
                ),
                _react2.default.createElement('div', { className: 'right-dog-foot right-dog-foot-jumping' })
              ),
              _react2.default.createElement('div', { className: 'doggy-cushion doggy-jumping-cushion' })
            )
          )
        )
      );
    }
  }]);
  return NotFound;
}(_react2.default.Component)) || _class);
exports.default = NotFound;
module.exports = exports['default'];